"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var noShake = /*#__PURE__*/(0, _styledComponents.css)(["transform:translate3d(0,0,0);"]);
var upShake = /*#__PURE__*/(0, _styledComponents.css)(["transform:translate3d(\"10px\",0,0);"]);
var downShake = /*#__PURE__*/(0, _styledComponents.css)(["transform:translate3d(\"-10px\",0,0);"]);
var shake = /*#__PURE__*/(0, _styledComponents.keyframes)(["from{", "}10%{", "}20%{", "}30%{", "}40%{", "}50%{", "}60%{", "}70%{", "}80%{", "}90%{", "}to{", "}"], noShake, downShake, upShake, downShake, upShake, downShake, upShake, downShake, upShake, downShake, noShake);
var _default = exports["default"] = shake;